import { Card, Container, Grid } from "@mui/material";
import FullScreenSpinner from "src/components/Spinner/FullScreenSpinner";
import { useApiQuery } from "src/hooks/useApiQuery";
import CategoryTable from "./CategoryTable";
import type { IProductCategory } from "src/Types/product.categories.types";

const CategoryList = () => {
	const { data: productCategories = [], isLoading } = useApiQuery<
		IProductCategory[]
	>({
		endPoint: `/api/fair/product-category`,
		queryKeys: ["ProductCategories"],
		params: {},
	});

	if (isLoading) {
		return <FullScreenSpinner />;
	}
	return (
		<>
			<Container sx={{ mt: 4 }} maxWidth="xl">
				<Grid
					container
					direction="row"
					justifyContent="center"
					alignItems="stretch"
					spacing={3}
				>
					<Grid item xs={12}>
						<Card>
							<CategoryTable
								categories={productCategories}
								isLoading={isLoading}
							/>
						</Card>
					</Grid>
				</Grid>
			</Container>
		</>
	);
};

export default CategoryList;
